import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const RootStyle = styled(Box)(({ theme }) => ({
  display: 'flex',
  minHeight: '100vh',
  overflow: 'auto',
  backgroundColor: theme.palette.root.mainLightGrey
}));
